import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest, select } from 'redux-saga/effects'
import { DBUserModel, FirebaseUserModel, UserModel } from '../models/UserModel'
import { toast } from 'react-toastify'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../../../helpers/remoteData'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
  GetDBUser: '[Get DB User] Action',
  GetDBUserSuccess: '[Get DB User] Success Action',
  GetDBUserFail: '[Get DB User] Fail Action',
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
  dbUser: undefined,
}

export interface IAuthState {
  user?: UserModel
  accessToken?: string
  dbUser?: DBUserModel
}

export const reducer = persistReducer(
  { storage, key: 'v100-demo1-auth', whitelist: ['user', 'accessToken'] },
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const accessToken = action.payload?.accessToken
        return { accessToken, user: undefined }
      }

      case actionTypes.Register: {
        const accessToken = action.payload?.accessToken
        return { accessToken, user: undefined }
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return { ...state, user }
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return { ...state, user }
      }

      case actionTypes.GetDBUserSuccess: {
        const dbUser = action.payload?.dbUser
        return { ...state, dbUser }
      }
      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: string) => ({ type: actionTypes.Login, payload: { accessToken } }),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: { accessToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: FirebaseUserModel) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user: UserModel) => ({ type: actionTypes.SetUser, payload: { user } }),
  getDBUser: () => ({ type: actionTypes.GetDBUser }),
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.GetDBUser, function* getDBUser() {
    const user = yield select((state) => state.auth.user)
    try {
      const userRef = doc(db, 'users', user.email)
      const docSnap = yield getDoc(userRef)
      let dbUser = {}
      if (docSnap.exists() && docSnap.data()) {
        dbUser = docSnap.data()
      }
      else {
        console.log('Database user does not exist')
      }
      
      yield put({ type: actionTypes.GetDBUserSuccess, payload: { dbUser } })
    }
    catch (e) {
      console.log('Database User error', e)
      // toast.error('Error getting database user')
    }
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    // @ts-ignore
    // const getToken = (state) => state.auth.accessToken;
    // @ts-ignore
    // let token = yield select(getToken)
    //const {data: user} = yield getUserByToken(token)
    yield put(actions.fulfillUser(user))
  })
}
